// Colori condivisi di podio e categorie gara (oro, argento, bronzo) — un solo posto invece di valori sparsi nei componenti
export const RANK_COLORS = { 1: '#FACC15', 2: '#C0C7D0', 3: '#D08A4E' }

export const CATEGORY_COLORS = {
  'Monumento':  { bg: '#1E1E1E', text: '#FACC15' },
  'WorldTour':  { bg: '#0057A8', text: '#FFFFFF' },
  'Pro Series': { bg: null,      text: '#FFFFFF' },   // bg = colore del brand (tc.rosa)
  'Grand Tour': { bg: '#7C3AED', text: '#FFFFFF' },
}
export const CATEGORY_ABBR = { 'Monumento': 'MON', 'WorldTour': 'WT', 'Pro Series': 'PRO', 'Grand Tour': 'GT' }
